import { MouseEvent, useCallback } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { useNavigationBlockerContext } from '../hooks/useNavigationBlockerContext'

export default function NavigationLink(props: LinkProps) {
  const { to, onClick } = props
  const { showNavigationDialog, shouldBlockNavigation } =
    useNavigationBlockerContext()

  const handleClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      const path = to.toString()

      if (path.startsWith('/')) {
        if (shouldBlockNavigation(path)) {
          event.preventDefault()
          event.stopPropagation()

          showNavigationDialog(path)
          return
        }
      }

      // Call the original onClick handler if provided
      if (onClick) {
        onClick(event)
      }
    },
    [showNavigationDialog, shouldBlockNavigation, onClick, to],
  )

  return <Link {...props} onClick={handleClick} />
}
